import styled, { css } from "styled-components";

const textParagraphSmSemi = css`
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 600;
`;

export const FieldsetWrapper = styled.fieldset<{ error?: boolean }>`
  margin: 0;
`;

export const Label = styled.label`
  ${textParagraphSmSemi}
  color: ${props => props.color || "var(--text-title, #080404)"};
  margin-bottom: 1rem;
`;